<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <div class="input-elements">
      <div class="input-cnt">
        <ovp-drop-down
          class="input__month"
          name="month"
          v-model="value.treatmentStart.month"
          :options="months"
          :theme="theme"
          :title="$t('date.month')"
        />

        <ovp-drop-down
          class="input__year"
          name="year"
          v-model="value.treatmentStart.year"
          :options="years"
          :theme="theme"
          :title="$t('date.year')"
        />
      </div>

      <div class="input__label">
        {{ $t('date.till') }}
      </div>

      <div class="input-cnt">
        <ovp-drop-down
          class="input__month"
          name="month"
          v-model="value.treatmentEnd.month"
          :options="months"
          :theme="theme"
          :title="$t('date.month')"
        />
        <ovp-drop-down
          class="input__year"
          name="year"
          v-model="value.treatmentEnd.year"
          :options="years"
          :theme="theme"
          :title="$t('date.year')"
        />
      </div>
    </div>
    <div class="input__hint">{{ autoHint }}</div>
  </div>
</template>

<script>
import { DateTimeHelper } from '@/helpers/DateTime'

export default {
  name: 'OvpDateSpan',

  props: {
    hint: {
      type: String,
      default: ''
    },

    required: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'light'
    },

    validate: {
      type: Object,
      default: () => {}
    },

    value: {
      type: Object,
      required: true
    }
  },

  computed: {
    autoHint () {
      const errors = Object.keys(this.validate?.$params ?? {}).filter(error => !this.validate[error])

      if (this.invalid && errors.length > 0) {
        return this.$t(`form.error.${errors[0]}`)
      } else {
        return this.hint
      }
    },

    classes () {
      return {
        'input': true,
        'input--invalid': this.invalid
      }
    },

    invalid () {
      return this.validate?.$invalid && this.validate?.$error
    },

    isRequired () {
      return this.required || this.validate?.required !== undefined
    },

    months () {
      return [
        { value: 1, text: this.$t('date.months.jan') },
        { value: 2, text: this.$t('date.months.feb') },
        { value: 3, text: this.$t('date.months.mar') },
        { value: 4, text: this.$t('date.months.apr') },
        { value: 5, text: this.$t('date.months.mai') },
        { value: 6, text: this.$t('date.months.jun') },
        { value: 7, text: this.$t('date.months.jul') },
        { value: 8, text: this.$t('date.months.aug') },
        { value: 9, text: this.$t('date.months.sep') },
        { value: 10, text: this.$t('date.months.okt') },
        { value: 11, text: this.$t('date.months.nov') },
        { value: 12, text: this.$t('date.months.dez') }
      ]
    },

    years () {
      return DateTimeHelper.getYearRange(10, 2)
    }
  }
}
</script>

<style name="mobile" scoped>
.input {
  display: flex;
  flex-direction: column;

  &-elements {
    display: flex;
    flex-direction: column;
    width: 100%;

    & >>> {
      .input__hint {
        display: none;
      }
    }
  }

  &-cnt {
    width: 100%;
    display: flex;
    flex-direction: row;

    &:first-child {
      margin: 10px 0 10px 0;
    }
  }

  &__month {
    flex: 1 1 50%;
  }

  &__year {
    flex: 1 1 50%;
  }

  &__label {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin-bottom: 10px;
  }

  &__hint {
    font-size: 15px;
    line-height: 20px;
    color: #999999;
    padding: 0 0 0 10px;

    transition: color .2s ease-in-out;
  }

  &--invalid {
    .input__hint {
      color: var(--c-error);
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .input {
    flex-direction: column;

    &-elements {
      flex-direction: row;
    }

    &-cnt {
      margin-top: 10px;

      &:first-child {
        margin: 10px 0 0 0;
      }
    }

    &__label {
      width: 75px;
      line-height: 40px;
      padding-top: 10px;
    }
  }
}
</style>
